const profileFeedback = require('./profile-feedback');

const t = require('engine/i18n/t');
t.i18n.add('profile', require('../locales/' + LANG + '.yml'));

profileFeedback();
